
/**
 * @see net/disy/cadenza/fileupload/service/UploadedFile.java
 */
export interface UploadedFileDto {
  signature: string;
  originalFileName: string;
  fileName: string;
}

export function toSearchParams (uploadedFile: UploadedFileDto): URLSearchParams {
  return new URLSearchParams(Object.entries(uploadedFile));
}
